export default __webpack_public_path__ + "static/media/EditUserProfilePlus.c84feef0.svg";